var exports = {
  "Q": "AttachmentEditModal.module__content___a1RBVX",
};

module.exports = exports;
